export const googleMapURL = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyA6IZvxomMAMQlW2dVcPYIuk-l0vcSpNUU&v=3.exp&libraries=places'
